export const SELECT_WORKSPACE = "SELECT_WORKSPACE";
export const REQUEST_WORKSPACES = "REQUEST_WORKSPACES";
export const RECEIVE_WORKSPACES = "RECEIVE_WORKSPACES";
export const CLEAN_WORKSPACES = "CLEAN_WORKSPACES";

export function selectWorkspace(workspace, orgId?) {
  return {
    type: SELECT_WORKSPACE,
    result: workspace,
    orgId,
  };
}

export function requestWorkspaces() {
  return {
      type: REQUEST_WORKSPACES,
  };
}

export function receiveWorkspaces(result) {
  return {
    type: RECEIVE_WORKSPACES,
    result,
  };
}

export function cleanWorkspaces() {
  return {
    type: CLEAN_WORKSPACES,
  };
}